import { useNavigate } from 'react-router';
import {
    Text,
    Box,
    Flex,
    Heading,
    Modal,
    ModalBody,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    useDisclosure,
    Progress,
    Spinner,
} from '@chakra-ui/react';

import PageHeader from 'layout/pageHeader';
import { useTranslation } from 'helpers/languages/translations';
import useUploadSection from './ImageUploadContainer';
import UploadSection from './UploadSection';
import ResultSection from './ResultSection';
import OverwriteModal from './OverwriteModal';
import { useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';

const ImageUpload = () => {
    const translate = useTranslation();
    const navigate = useNavigate();
    const disclosure = useDisclosure();
    const uploadSectionProps = useUploadSection(disclosure);
    const userInfo = useGetUserInfoSelector();
    const readonly = !userInfo?.user_groups?.includes(19);

    if (readonly) {
        window.location.href = '/';
        return null;
    }

    const goBack = () => {
        navigate(-1);
    };

    return (
        <Box>
            <PageHeader
                pageTitle={translate('pictures.upload.title') as string}
                icon={{ name: 'arrowBack', props: { onClick: goBack } }}
            />
            <Box px="32px">
                <Flex justifyContent="start">
                    <Heading as="h2" fontWeight="semibold" fontSize="18px" mb="18px">
                        {translate('pictures.upload')}
                    </Heading>
                </Flex>
                <Flex fontSize="sm" direction="row">
                    <UploadSection {...uploadSectionProps} />
                    <ResultSection {...uploadSectionProps} />
                </Flex>
            </Box>
            <Modal useInert={false} isCentered isOpen={disclosure.isOpen} onClose={() => {}}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>
                        <Flex alignItems="center">
                            <Text as="h3">{translate('file.upload')}</Text>
                            <Spinner speed="0.65s" emptyColor="gray.200" color="blueMain" size="md" ml={2} />
                        </Flex>
                    </ModalHeader>
                    <ModalBody fontSize="sm">
                        <Progress value={uploadSectionProps.buffer} colorScheme={'blue'} borderRadius={3} />
                    </ModalBody>
                </ModalContent>
            </Modal>
            <OverwriteModal {...uploadSectionProps} />
        </Box>
    );
};

export default ImageUpload;
